import { Modal } from "reactstrap";
import styles from './EditProfileModal.module.scss'
import { User, UserRole } from "../../../interfaces/interfaces";
import { HiTrash } from 'react-icons/hi';
import { RiCloseFill, RiDeleteBin6Line } from 'react-icons/ri';
import { useDebugValue, useEffect, useState } from "react";
import { digitsOnly, getLocalUser, removeSpace } from "../../../components/functions/utilities";
import { RestS } from "../../../rest/rest-service";
import { UsersRestS } from "../../../rest/users-rest-service";
import { allowOnlyNumber, allowOnlyNumberPlus } from "./NewUserModal";
import { mobileNumberValidationDis } from "../../../components/functions/formValidation";
import OutlinedFormInput from "../../Finance/components/OutlinedFormInput/OutlinedFormInput";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { MdOutlineClose } from "react-icons/md";
import WorkspaceSelectTable from "./WorkspaceSelectTable";

type Props = {
  toggle: () => void;
  visible: boolean;
  user: User,
  setSelectedUser: any,
  getUserData: any
};

enum TabRole {
  userDetails = 'userDetails',
  brandAccess = 'brandAccess'
}

type inputProps = {
  label: string,
  maxLength: any,
  placeholder: string,
  value: any,
  setValue: any,
  disabled: boolean,
  message: string
}

export const EditProfileInput = ({ label, maxLength, placeholder, value, setValue, disabled = false, message = 'none' }: inputProps) => {
  message = message == '' ? 'none' : message
  if (label == "Phone Number") {
    return (
      <>
        <div className={styles.editInputElePH}>
          <p>{label}</p>
          <div className={styles.phoneNumber}>
            <img src={'https://assets.clickmerito.com/images/whatsapp.svg'}></img>
            <input defaultValue={'+91'} className={styles.nine} maxLength={maxLength['phoneCode']} disabled={disabled} placeholder={'+91'} value={value['phoneCode']} onChange={setValue['phoneCode']} />
            <input className={styles.num} maxLength={maxLength['phoneNumber']} disabled={disabled} placeholder={placeholder} value={value['phoneNumber']} onChange={setValue['phoneNumber']} />
          </div>
        </div>
      </>
    )
  }
  return (
    // <OutlinedFormInput
    //     {...props.input}
    //     inpuType="number"
    //     disabled={isInstallmentSectionDisabled}
    //     name={props.input.name}
    //     value={props.input.value}
    //     onChange={(e) => {
    //         const numericValue = parseNumberForDB(e.target.value, false);
    //         props.input.onChange(numericValue);
    //     }}
    //     error={props.meta.error}
    //     touched={props.meta.touched}
    //     onBlur={(e) => {
    //         const value = props.input.value;
    //         const formattedValue = onBlurFormatNumber(value, 0);
    //         props.input.onChange(formattedValue);
    //         props.input.onBlur(e);
    //     }}
    //     unitPlaceHolder={'₹'}
    //     maxLength={21}
    //     isCurrency={true}
    // />
    <div className={styles.editInputEle}>
      <p>{label}</p>
      <input className={disabled ? styles.disabledInput : ''} maxLength={maxLength} disabled={disabled} placeholder={placeholder} value={value} onChange={setValue} />
      <p style={{ display: message == 'none' ? 'none' : 'block' }} className={styles.error}>{message}</p>
    </div>
  )
}

const EditProfileModal = ({ visible, toggle, user, setSelectedUser, getUserData }: Props) => {
  const [name, setName] = useState(user.name == null ? '' : user.name)
  const [designation, setDesignation] = useState(user.designation == null ? '' : user.designation)
  const [phoneCode, setPhoneCode] = useState(user.phoneCode == null ? '+91' : user.phoneCode)
  const [contact, setContactNumber] = useState(user.phoneNumber == null ? '' : user.phoneNumber)
  const [whatsappReport, setWhatsappReport] = useState(user.whatsappReport ? user.whatsappReport : 0)
  const [role, setRole] = useState<any>(user.role)
  const [updateDisable, setUpdateDisable] = useState(true)
  const renderName = (name) => {
    let userNameSplit = name.split(" ");
    return `${userNameSplit[0].charAt(0)}`.toUpperCase();
  };
  const [reportIds, setReportIds] = useState(new Set());
  const currUser = getLocalUser()
  const [tab, setTab] = useState<TabRole>(TabRole.userDetails)

  const close = () => {
    toggle()
    setSelectedUser(null)
  }

  useEffect(() => {
    console.log('Getting reports for user', user.id)
    RestS.getReportsByUserId(1, 1000, '', true, user.id)
      .then((res) => {
        if (currUser.role == 'Agency') {
          const companyIds = [
            ...new Set(
              res.reports.flatMap((ele: any) => ele.report.company_ids)
            )
          ].map(Number);
          console.log('reports', companyIds)
          setReportIds(new Set(companyIds))
        } else {
          const reportIds = res.reports.map((ele: any) => ele.report.id);
          console.log('reports', reportIds)
          setReportIds(new Set(reportIds))
        }
      })
  }, [user.id])

  useEffect(() => {
    // console.log(designation != user.designation || contact != user.phoneNumber || role != user.role)
    // console.log(designation, user.designation)
    setUpdateDisable(() => {
      if (designation != (user.designation == null ? '' : user.designation)
        || contact != (user.phoneNumber == null ? '' : user.phoneNumber)
        || role != user.role
        || whatsappReport != user.whatsappReport
        || phoneCode != user.phoneCode
        || name != user.name
      ) {
        return false
      } else return true
    })
  }, [name, designation, contact, role, phoneCode, whatsappReport])

  const inputEle = [
    {
      label: 'Name *',
      disabled: false,
      placeholder: 'Enter Name',
      setValue: (e) => { setName(e.target.value) },
      value: name,
      maxLength: 60
    },
    {
      label: 'Email *',
      disabled: true,
      placeholder: 'Enter Email Address',
      setValue: () => { },
      value: user.email,
      maxLength: 60
    }, {
      label: 'Designation',
      disabled: false,
      placeholder: 'Enter designation',
      setValue: (e) => { setDesignation(e.target.value) },
      value: designation,
      maxLength: 60
    }, {
      label: 'Phone Number',
      disabled: false,
      placeholder: 'Enter phone number',
      setValue: {
        phoneCode: (e) => {
          const sanitizedValue = removeSpace(e.target.value);
          if (allowOnlyNumberPlus(sanitizedValue)) {
            setPhoneCode(sanitizedValue)
          }
        },
        phoneNumber: (e) => {
          const sanitizedValue = digitsOnly(e.target.value);
          if (allowOnlyNumber(sanitizedValue)) {
            setContactNumber(sanitizedValue)
          }
        }
      },
      value: {
        phoneCode: phoneCode,
        phoneNumber: contact
      },
      maxLength: {
        phoneCode: 4,
        phoneNumber: 15
      },
    }]

  useEffect(() => {
    if (!mobileNumberValidationDis(contact)) {
      setWhatsappReport(0)
    }
  }, [contact])

  const updateUser = () => {
    UsersRestS.updateUser({
      ...user,
      name: name,
      designation: designation,
      role: role,
      phoneNumber: contact,
      whatsappReport,
      phoneCode: phoneCode != '' ? phoneCode : '+91'
    }).then(() => {
      getUserData()
    })

    // Update report link recipient
    console.log(reportIds)
    RestS.updateReportLinkRecipients(Array.from(reportIds) as any, user)
  };

  return (
    <>
      {
        user ? <Modal
          size="md"
          centered
          isOpen={visible}
          toggle={() => {
            close()
          }}
        >
          <div className={styles.cont}>
            <div className={styles.innerCont}>
              <div>
                <div className={styles.header}>
                  <div className={styles.leftCont}>
                    <h1>Update Team Member</h1>
                    {/* <p>Edit user details</p> */}
                  </div>
                  <div>
                    {/* {
                      currUser.id == user.id ? null :
                        <HiTrash className={styles.deleteBtn} onClick={() => {
                          if (user.companyId != currUser.companyId) {
                            RestS.deleteInvitedUser(user.id)
                          } else {
                            UsersRestS.deleteUser(user.id)
                          }
                        }} />
                    } */}
                    <MeritoButton
                      type="tertiary"
                      size="md"
                      onlyIcon={true}
                      onClick={() => { close() }}
                      icon={<MdOutlineClose />}
                    />
                  </div>
                </div>
                <div className={styles.tabContainer}>
                  <div
                    className={`${styles.tab} ${tab == TabRole.userDetails ? styles.active : ''}`}
                    onClick={() => { setTab(TabRole.userDetails) }}
                  >
                    User Details
                  </div>
                  {
                    currUser.email == user.email ?
                      null :
                      currUser.role != UserRole.Agency ?
                        <div
                          className={`${styles.tab} ${tab == TabRole.brandAccess ? styles.active : ''}`}
                          onClick={() => { setTab(TabRole.brandAccess) }}
                        >
                          Workspace Access
                        </div> :
                        <div
                          className={`${styles.tab} ${tab == TabRole.brandAccess ? styles.active : ''}`}
                          onClick={() => { setTab(TabRole.brandAccess) }}
                        >
                          Brand Access
                        </div>
                  }
                </div>
              </div>
              {
                tab == TabRole.userDetails ?
                  <div className={styles.body}>
                    {/* <div>
                    <div style={{ backgroundColor: `#${user.color}` }} className={styles.userIcon}>
                      {renderName(user.name)}
                    </div>
                    <h2>{user.name}</h2>
                  </div> */}
                    {inputEle.map((ele) => {
                      return <EditProfileInput label={ele.label} maxLength={ele.maxLength} placeholder={ele.placeholder} value={ele.value} setValue={ele.setValue} disabled={ele.disabled} message="" />
                    })}
                    {
                      currUser.role == 'Agency' ? null :
                        <div className={styles.editInputEle}>
                          <p>User Type</p>
                          <select value={role} onChange={(e) => { setRole(e.target.value) }} className={`${user.role == 'Agency' || currUser.id == user.id ? styles.disabledInput : ''}`} disabled={user.role == 'Agency' || currUser.id == user.id}>
                            <option>Admin</option>
                            <option>User</option>
                          </select>
                        </div>
                    }
                    <div className={styles.whatsAppReport}>
                      <input
                        type="checkbox"
                        disabled={!mobileNumberValidationDis(contact)}
                        checked={!!(whatsappReport)}
                        onChange={() => { setWhatsappReport(e => Number(!!!e)) }}
                      />
                      <div className={styles.whatsAppReportText}>
                        Receive communication from Merito on WhatsApp
                      </div>
                    </div>
                  </div>
                  : (
                    <div style={{ padding: "10px" }}>
                      <WorkspaceSelectTable
                        reportIds={reportIds}
                        setReportIds={(reportIds) => {
                          setReportIds(reportIds);
                          setUpdateDisable(false)
                        }}
                      />
                    </div>
                  )
              }
            </div>
            <div className={styles.footer}>
              <MeritoButton
                type="destructive-ghost"
                size="md"
                icon={<RiDeleteBin6Line />}
                btnText="Delete"
                onClick={() => {
                  if (user.companyId != currUser.companyId) {
                    RestS.deleteInvitedUser(user.id)
                  } else {
                    UsersRestS.deleteUser(user.id)
                  }
                }}
              />
              <div className={styles.rightFooterCont}>
                <MeritoButton
                  type="tertiary"
                  size="md"
                  onClick={() => { close() }}
                  btnText="Cancel"
                />
                <MeritoButton
                  type="primary-1"
                  size="md"
                  btnText="Update"
                  onClick={() => {
                    if (!updateDisable) {
                      updateUser();
                      close()
                    }
                  }}
                  disabled={updateDisable}
                />
              </div>
            </div>
          </div>
        </Modal > : null
      }
    </>
  )
}

export default EditProfileModal